/* ==========================================================================
   OUR PHILOSOPHY — page behaviour.
   Four independent IIFEs; each one no-ops if its markup is absent, so the
   file is safe to load on any page.
   ========================================================================== */

/* --- 1. scroll reveal ------------------------------------------------- */
(function () {
  'use strict';
  var els = document.querySelectorAll('.phil__rv');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();

/* --- 2. hero analysis reticles ---------------------------------------- */
(function () {
  'use strict';
  var figs = [].slice.call(document.querySelectorAll('[data-phil-retic]'));
  if (!figs.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    figs.forEach(function (f) { f.classList.add('is-lit'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var idx = figs.indexOf(entry.target);
      setTimeout(function () { entry.target.classList.add('is-lit'); }, 500 + idx * 360);
      io.unobserve(entry.target);
    });
  }, { threshold: 0.3 });

  figs.forEach(function (fig) {
    io.observe(fig);
    fig.addEventListener('mouseenter', function () {
      fig.classList.remove('is-lit');
      void fig.offsetWidth; /* force reflow so the transition replays */
      fig.classList.add('is-lit');
    });
  });
})();

/* --- 3. lipid bilayer diagram ----------------------------------------- */
(function () {
  'use strict';
  var svg = document.getElementById('phil-bilayer');
  if (!svg) return;

  var NS = 'http://www.w3.org/2000/svg';
  var COUNT = 15;
  var frag = document.createDocumentFragment();

  for (var i = 0; i < COUNT; i++) {
    var x = 6 + i * (88 / (COUNT - 1));
    var delay = i * 36 + 'ms';

    /* two opposed rows of phospholipids, tails facing inward */
    [[34, 1], [66, -1]].forEach(function (row) {
      var y = row[0];
      var dir = row[1];

      var head = document.createElementNS(NS, 'circle');
      head.setAttribute('cx', x);
      head.setAttribute('cy', y);
      head.setAttribute('r', 3.1);
      head.setAttribute('class', 'phil-lip-head');
      head.style.animationDelay = delay;
      frag.appendChild(head);

      [-1.15, 1.15].forEach(function (offset) {
        var tail = document.createElementNS(NS, 'path');
        tail.setAttribute(
          'd',
          'M' + (x + offset) + ' ' + (y + dir * 3.1) + ' q ' + offset * 1.6 + ' 6 0 12'
        );
        tail.setAttribute('class', 'phil-lip-tail');
        tail.style.animationDelay = delay;
        frag.appendChild(tail);
      });
    });
  }

  svg.appendChild(frag);
})();

/* The results gallery is now snippets/philosophy-before-after.liquid, a copy of
   the homepage slider. It ships its own filtering and carousel JS, so there is
   nothing to do here. */
